import { Avatar, Flex } from "@fluentui/react-northstar";
import styled from "styled-components";
import { useAuthDetailStore } from "../../../stores/useAuthStore";
import AlertInfo from "../../../components/Alerts/Info";

export default function Sidebar({
    task_created_by,
    task_due_date,
    status,
    approval_date,
}) {
    const {
        first_name = "",
        last_name = "",
        company = { name: null },
    } = useAuthDetailStore((state) => state.detail);
    return (
        <SidebarWrapper>
            <AvatarBlock>
                <Avatar name={`${first_name} ${last_name}`} size="large" />
                <Name>{`${first_name} ${last_name}`}</Name>
                <Sub>{company.name ?? "--"}</Sub>
            </AvatarBlock>
            {status === 1 && (
                <Flex styles={{ marginTop: "14px" }}>
                    <AlertInfo
                        title={"✓ Fiche validée"}
                        content={`Votre fiche a été acceptée par votre responsable RH le ${approval_date.replace(
                            " ",
                            " à "
                        )}.`}
                        success
                    />
                </Flex>
            )}
            {status === 3 && (
                <Flex column>
                    <Flex styles={{ marginTop: "14px" }}>
                        <AlertInfo
                            title={"↩ Fiche refusée"}
                            content={
                                "Des corrections sont requises. Merci de les apporter et de soumettre à nouveau."
                            }
                            error
                        />
                    </Flex>
                    <ConfidentialNote>
                        Un email récapitulatif vous a été envoyé avec le détail
                        des corrections.
                    </ConfidentialNote>
                </Flex>
            )}
            {status === 2 && (
                <Flex column>
                    <Flex styles={{ marginTop: "14px" }}>
                        <AlertInfo
                            title={"⏳ Fiche en cours de vérification"}
                            content={
                                "Votre fiche a été soumise et est en attente de validation par votre responsable RH."
                            }
                            warning
                        />
                    </Flex>
                    <ConfidentialNote>
                        Votre responsable RH a reçu un email l'informant de
                        votre soumission.
                    </ConfidentialNote>
                </Flex>
            )}
            {status === 0 && (
                <Flex column gap="gap.medium">
                    <TaskAssignation>
                        <strong style={{ display: "block", marginBottom: 4 }}>
                            📋 Tâche assignée
                        </strong>
                        Compléter votre fiche de renseignement
                        <br />
                        <span style={{ fontSize: 11 }}>
                            Échéance : <strong>{task_due_date}</strong>
                        </span>
                        <br />
                        <span style={{ fontSize: 11 }}>
                            Créée par : {task_created_by ?? "--"}
                        </span>
                    </TaskAssignation>

                    <ConfidentialNote>
                        Ces informations sont <strong>confidentielles</strong>{" "}
                        et utilisées à des fins administratives (paie, contrat,
                        assurances).
                    </ConfidentialNote>
                </Flex>
            )}
        </SidebarWrapper>
    );
}

const SidebarWrapper = styled.div`
    width: 256px;
    min-width: 256px;
    background: var(--bg-card);
    border-right: 1px solid var(--border);
    padding: 24px 16px;
`;

const AvatarBlock = styled.div`
    text-align: center;
    padding-top: 10px;
`;

const AvatarCircle = styled.div`
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: var(--purple-light);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 17px;
    color: var(--purple);
    margin: 0 auto 10px;
`;

const Name = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: var(--text);
`;

const Sub = styled.div`
    font-size: 11px;
    color: var(--text-tert);
    margin-top: 2px;
`;

const TaskAssignation = styled.div`
    background: var(--green-light);
    border: 1px solid var(--green-mid);
    border-radius: var(--radius);
    padding: 12px;
    font-size: 12px;
    color: var(--green-dark);
    line-height: 1.6;
    margin-top: 14px;
`;

const ConfidentialNote = styled.div`
    font-size: 11px;
    color: var(--text-tert);
    line-height: 1.7;
    padding: 10px;
    background: var(--bg-secondary);
    border-radius: var(--radius);
    border: 1px solid var(--border);
`;
